import {ApiTags} from '@nestjs/swagger';
import { Controller, Post, Body, Req } from '@nestjs/common';
import {ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { BlanchingCookingAdapter } from '../dto/blanching-cooking.adapter';

import { BlanchingCooking } from '../entities/blanching-cooking.entity';
import { SoakingSampleTestService} from './soaking-sample-test.service';
import {  AllSoakingSampleTestReponseModel, LogIdRequest, SoakingSampleTestDto, SoakingSampleTestReponseModel } from '@gtpl/shared-models/production-management';
import { SoakingSampleTestDTO } from '../dto/soaking-sample-test.dto';


@ApiTags('soaking-sample-test')

@Controller('soaking-sample-test')
export class SoakingSampleTestController {


    constructor(
        private service: SoakingSampleTestService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}
    @Post('/createSoakingSampleTest')
    async createSoakingSampleTest(@Body() dto: SoakingSampleTestDTO, isUpdate: boolean = false): Promise<SoakingSampleTestReponseModel>{
    try{
        return await this.service.createSoakingSampleTest(dto, false);        
    } catch(error){
        return this.applicationExceptionHandler.returnException(SoakingSampleTestReponseModel, error);
    }
    } 

    @Post('/getSamplesInfoBylogId')
    async getSamplesInfoBylogId(@Body() req : LogIdRequest): Promise<AllSoakingSampleTestReponseModel>{
    try{
        return await this.service.getSamplesInfoBylogId(req);        
    } catch(error){
        return this.applicationExceptionHandler.returnException(AllSoakingSampleTestReponseModel, error);
    }
    } 
}
